import styled from "styled-components";
import { Button } from "./Buttons.styled";

export const StyledPopupErrorMessage = styled.div`
  color: #7a0000;
  background-color: #ffe1e1;
  border: 1px solid #ff9d9d;
  border-radius: 10px;
  padding: 12px 16px;
  margin: 15px 0;
  font-size: 14px;
  line-height: 1.5;
`;

export const StyledPopupErrorList = styled.ul`
  color: #7a0000;
  background-color: #ffe1e1;
  border: 1px solid #ff9d9d;
  border-radius: 10px;
  padding: 12px 16px 12px 32px;
  margin: 0 0 15px;
  font-size: 14px;
  line-height: 1.5;
`;

export const StyledPopupForm = styled.form`
  display: flex;
  flex-direction: column;
  input {
    border-radius: 10px;
    height: 30px;
    border-color: #608cdf;
    width: 50%;
    min-width: 250px;
    margin-bottom: 15px;
  }
`;

export const StyledOuterPopup = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 2%;

  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 1001;

  /* Prevent scroll chaining - stops scroll from propagating to background */
  overscroll-behavior: contain;
  touch-action: pan-y;

  @media (max-width: 600px) {
    height: 100lvh;
  }
`;

export const StyledInnerPopup = styled.div.attrs({
  'data-scroll-lock-scrollable': true
})`
  padding: 32px;
  width: 100%;
  max-width: 1200px;
  max-height: 90vh;
  background-color:#8dabe2;
  color: #ffffff;
  border-radius: 10px;
  box-shadow: 12px 12px 2px 1px rgba(255, 255, 255, 0.2);
  font-size:20px;
  overflow-y: auto;

  /* Prevent scroll chaining within the modal */
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch; /* Smooth scrolling on iOS */

  @media (max-width: 600px) {
    height: 100lvh;
    max-height: 100lvh;
    padding:2%;
  }
`;

export const StyledInnerPopup_Small = styled.div.attrs({
  'data-scroll-lock-scrollable': true
})`
  padding: 32px;
  width: 100%;
  max-width: 600px;
  max-height: 90vh;
  background-color:#8dabe2;
  color: #ffffff;
  border-radius: 10px;
  box-shadow: 12px 12px 2px 1px rgba(255, 255, 255, 0.2);
  font-size:20px;
  overflow-y: auto;

  /* Prevent scroll chaining within the modal */
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch; /* Smooth scrolling on iOS */

  @media (max-width: 600px) {
    height: auto;
    max-height: 90vh;
    padding:2%;
  }
`;

export const StyledMoveOrUseContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media (max-width: 600px) {
    gap: 10px;
  }
`;

export const StyledMoveOrUseSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  border: solid #ffffff 2px;
  border-radius: 10px;
  padding: 16px;
  box-sizing: border-box;

  @media (max-width: 600px) {
    gap: 6px;
    padding: 10px;
    border-width: 1px;

    h2 {
      font-size: 16px;
      margin: 4px 0;
    }
  }
`;

export const StyledPopupTextArea = styled.textarea`
  border-radius: 10px;
  border-color: #608cdf;
  width: 100%;
  min-width: 250px;
  max-width: 100%;
  min-height: 90px;
  margin-bottom: 15px;
  padding: 8px;
  font-size: 14px;
  box-sizing: border-box;

  @media (max-width: 600px) {
    min-width: 0;
    min-height: 70px;
    margin-bottom: 0;
    padding: 6px;
    /* iOS Safari auto-zooms the page on focus for any field under 16px */
    font-size: 16px;
  }
`;

export const StyledPopupButton = styled(Button)`
  background-color: #fff;
  height: 50px;
  width:auto;
  min-width: 150px;
`;

export const StyledMoveOrUseButton = styled(StyledPopupButton)`
  @media (max-width: 600px) {
    height: 36px;
    min-width: 0;
    font-size: 13px;
    padding: 0 10px;
  }
`;

export const StyledCancelWrapper = styled.div`
  margin-top: 15px;

  @media (max-width: 600px) {
    margin-top: 8px;
  }
`;

export const StyledButtonRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 10px;

  @media (max-width: 600px) {
    gap: 6px;
  }
`;